module.exports = __webpack_public_path__ + "files/94ca184d7a393a1499c9b7d187d25c64.svg";